<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout class="eservice_inner_wrap login_wrap type2">
      <v-flex class="pa-0 login_content type2">
        <v-card class="login_form type2 type3" flat>
          <div class=" d-flex align-center">
            <h2 class="logo mb-25">
              <v-img src="~@/assets/img/logo_auth.png" alt="EGPO" @click="$router.push('/main')" style="cursor:pointer;"></v-img>
            </h2>
            <v-spacer></v-spacer>
            <div class="lang__selector ty2">
              <v-switch
                v-model="rtl"
                color="red"
                value="red"
                class=""
                hide-details
                @change="fnSetLocale()"
              ></v-switch>
              <v-spacer class="hidden_lr5"></v-spacer>
              <span v-if="rtl">{{ $t('common.common.arabic') }}</span>
              <span v-else>{{ $t('common.common.english') }}</span>
            </div>
          </div>

          <h3 class="out_title">{{ $t('signup.title') }}</h3>

          <v-card-text class="auth_header_info mt-20 ty2">
            <h2 class="auth_header_title">{{ $t('signup.usertype.fields.auth_header_title') }}:</h2>
            <div class="auth_header_desc ty2">
              <p class="fcc">{{ $t('signup.usertype.fields.auth_header_desc1') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc1_sub1') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc1_sub2') }}</p>
              <p class="fcc">{{ $t('signup.usertype.fields.auth_header_desc2') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc2_sub1') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc2_sub2') }}</p>
              <p class="fcc">{{ $t('signup.usertype.fields.auth_header_desc3') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc3_sub1') }}</p>
              <p class="fcc">{{ $t('signup.usertype.fields.auth_header_desc4') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc4_sub1') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc4_sub2') }}</p>
              <p class="fcc">{{ $t('signup.usertype.fields.auth_header_desc5') }}</p>
              <p class="sup_lr">{{ $t('signup.usertype.fields.auth_header_desc5_sub1') }}</p>
            </div>
          </v-card-text>

          <v-card-text class="pa-0 mt-55 sub_content_wrap re__mod__btnwrap align-center">
            <h3 class="auth_btn_title" style="color:#a01c2a">{{ $t('signup.usertype.fields.auth_btn_title') }}</h3>
            <v-btn class="text_btn br_none mt-18" width="300" height="55" outlined text :to="{ path : '/signup/agent/email' }"><b>{{ $t('common.button.yes') }}</b>, {{ $t('signup.usertype.fields.btn_1') }}</v-btn>
            <v-btn class="text_btn mt-25 br_none" width="300" height="55" outlined text :to="{ path : '/signup/common/email' }"><b>{{ $t('common.button.no') }}</b>, {{ $t('signup.usertype.fields.btn_2') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import en from 'vee-validate/dist/locale/en'
import ar from 'vee-validate/dist/locale/ar'
import store from '@/store'
import requestApi from '@/utils/requestApi'
import eventBus from '@/utils/eventBus'

export default {
  name: 'UserType',
  components: {
  },
  data () {
    return {
      fooinfo1 :true,
      fooinfo2 :false,
      fooinfo3 :false,
      rtl: (store.state.api.language === 'en') ? null: 'red'
    }
  },
  created () {
  },
  mounted () {
    window.scrollTo(0, 0)
    this.fnCheckIpAddress()
  },
  methods: {
    fnCheckIpAddress() {
      requestApi({
        url: '/config/codes/ipaddress',
        method: 'GET',
        callback: (res) => {
          if (res.res_code !== '200') {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    },
    fnSetLocale() {
      if (this.$vuetify.rtl) {
        this.rtl = null
        this.$vuetify.rtl = false
        this.$i18n.locale = 'en'
        this.$vuetify.lang.current = 'en'
        this.$validator.localize('en', en)
        store.dispatch('SetLanguage', 'en')
      } else {
        this.rtl = 'red'
        this.$vuetify.rtl = true
        this.$i18n.locale = 'ar'
        this.$vuetify.lang.current = 'ar'
        this.$validator.localize('ar', ar)
        store.dispatch('SetLanguage', 'ar')
      }
    },
  }
}
</script>

<style lang="less">
</style>
